export const VALIDSIGN_SUPPORT_URL = 'https://support.validsign.eu/hc';
export const SUPPORT_REQUEST_PATH = '/requests/new';
export const SUPPORT_OVERVIEW_PATH = '/categories/6626431968397-ValidSign';
export const VALIDSIGN_SUPPORT_API_URL = 'https://support.validsign.eu/api/v2/help_center';
export const DEFAULT_SUPPORT_LOCALE = 'nl';

/** Below are all the articles per "November 4th 2024" based on title + id.
 * With this setup we can use the readable titles in the code but fetch the articles
 * based on the id.
 */
export const ZENDESK_ARTICLES = {
    // SEND A TRANSACTION
    CREATING_A_TRANSACTION_PAGE: '17510399555085',
    SEND_OUT_A_DOCUMENT_THROUGH_VALIDSIGN_DASHBOARD: '7427335573901',
    CREATING_A_TEMPLATE: '6721426813965',
    CREATING_AND_USING_TEMPLATES: '7398887829389',
    TRANSACTION_SETTINGS: '7289514419469',
    WALKTHROUGH_VALIDSIGN_ENVIRONMENT: '7402319879821',
    USING_THE_OPTIONAL_SIGNATURE: '7484403965069',
    EDIT_MODIFY_TRANSACTION: '7425695897613',
    ADDING_FIELDS_TO_A_DOCUMENT: '7395507824525',
    REQUEST_AN_ATTACHMENT_FROM_A_SIGNER: '7447179855501',
    SET_SIGNING_ORDER_DOCUMENT_ORDER: '7401309388045',
    SET_UP_2FA_AUTHENTICATION: '7426532651789',
    DELETE_A_SIGNER: '7425376200589',
    SEND_OUT_FROM_DASHBOARD: '6721149425549',
    CREATING_BULK_TRANSACTIONS: '360035187691',
    APPROVE_INSTEAD_OF_SIGN: '7400160686093',
    ERROR_MESSAGE_UPLOAD_DOCUMENT: '7424858399757',
    DUPLICATE_FIELDS_ALL_PAGES: '27906258922381',
    DYNAMIC_SIGNING_ORDER: '6653070044173',
    SEND_SIGNING_REQUEST_WITH_IDIN: '7447242419085',
    SET_DOCUMENT_VISIBILITY: '7401774280461',
    REQUIRED_FIELDS: '7401225426445',
    HIDE_DOCUMENTS_FROM_CERTAIN_SIGNERS: '7400829240333',
    ADDITIONAL_SETTINGS: '7400341840781',
    SEND_REMINDER: '7400095989133',
    SET_DOCUMENT_VISIBILITY_AGAIN: '7398445933325',
    SENDING_WITH_VALIDSIGN: '7426212013709',
    SENDING_REMINDER_TO_SIGN: '7397717185165',
    CLICK_SIGNATURE_CAPTURE_SIGNATURE: '7395470039053',
    REVIEW_REQUESTED_ATTACHMENT: '9155850302733',
    RECIPIENT_SETTINGS: '7343952811405',
    WORKING_WITH_LAYOUTS_TEMPLATES: '7339399059853',
    AUTO_REMINDER_SCHEDULE: '7339194813325',
    REQUEST_REQUIRE_ATTACHMENT: '7339014708877',
    SPECIFY_EXPIRATION_DATE: '7288860665613',
    REQUEST_ATTACHMENT_FROM_SIGNER: '7288677189389',
    FORWARD_SIGNATURE_SOMEONE_ELSE: '7288473173261',
    USING_FASTTRACK: '6633167102605',
    DIFFERENT_WAYS_2FA: '6180307129229',
    OPTIONS_PENDING_TRANSACTION: '6156012443021',
    EDIT_PENDING_TRANSACTION: '6154306793229',
    FORWARD_SIGNATURE_SOMEONE_ELSE_AGAIN: '360012275992',

    // SIGNING A DOCUMENT WITH VALIDSIGN
    SIGN_DOCUMENT_FROM_EMAIL: '7446689286413',
    VALID_SIGN_SIGNING_CEREMONY: '6311842644621',
    SIGNING_FROM_DASHBOARD: '7484713398285',
    DOWNLOAD_DOCUMENT_FROM_ENVIRONMENT: '7483678283533',
    SIGN_WITH_SMARTPHONE_TABLET: '7402910564365',
    MISSING_SIGNATURE_TEXT_MESSAGE: '7426630913677',
    SIGN_WITH_PERSONAL_CERTIFICATE: '7425249319309',
    SIGN_DOCS_USING_IPHONE: '7402059511181',
    SIGN_DOCUMENT_FROM_EMAIL_AGAIN: '7398160816909',
    DOWNLOAD_DOCUMENT_FROM_EMAIL: '7483167335309',
    DOWNLOAD_EVIDENCE_SUMMARY: '7397884944653',
    DECLINE_TRANSACTION: '6312044943757',
    SIGN_ON_MOBILE_DEVICES: '360002886092',

    // MANAGING YOUR VALIDSIGN ACCOUNT OR ENVIRONMENT
    TRANSACTION_COMPLETED_PAGE: '17510436849037',
    TRANSACTION_IN_PROGRESS_PAGE: '17510421015693',
    RETENTION_PERIOD: '16251188771469',
    EVENT_NOTIFICATIONS: '12569070446349',
    REMOVE_USER: '11093742838925',
    MY_ACCOUNT: '7509799850893',
    DASHBOARD: '6677668432909',
    CREATING_USERS: '7401055240845',
    AUTHORIZING_SOMEONE: '360012261692',
    SECURITY_SETTINGS: '7491858658061',
    ENTERPRISE_ADMINISTRATION: '6155529596301',
    REPORTS_PAGE: '7485493419021',
    CHANGE_SENDER_OF_MAILS: '7427179779213',
    SINGLE_SIGN_ON_POSSIBILITIES: '7427096381197',
    CUSTOM_LOGOS_BRANDING: '7426995649421',
    RETRIEVE_API_KEY: '7426674952717',
    DIGITAL_SIGNATURE_SECURITY: '7425594862605',
    CHANGE_SIGNATURE: '7400971046669',
    VALIDSIGN_DASHBOARD: '7398488456077',
    ARCHIVE_DELETE_TRANSACTION: '7288368179085',
    ACCESS_DELEGATION: '6722044007437',
    ADMIN_SETTINGS: '360001508292',
    SAVE_SIGNATURE_IN_ACCOUNT: '6721179107469',
    PERSONAL_INFORMATION: '6632623601293',
    PERSONAL_PREFERENCES: '6632445424269',
    CUSTOM_FIELDS: '6631593335821',
    CHANGE_PASSWORD: '6631055439117',
    CHANGE_LANGUAGE: '6182665252493',
    DIFFERENT_THEMES: '6177595901837',
    SUBENVIRONMENT: '6176908942733',
    SIGNING_CEREMONY_BRANDING: '6157615391501',
    EMAILS_SENT_TWICE: '360038791152',
    CHANGE_SIGNATURE_AGAIN: '360001383191',

    // VALIDSIGN TEXT TAGS
    USING_TEXT_TAGS: '7426068306829',
    TEXT_TAG_STRUCTURE: '4725067251469',
    EXAMPLE_TEXT_TAG_DOCS: '4725046509197',
    TEXT_TAG_USAGE: '4724971679117',
    USING_TEXT_TAGS_AGAIN: '360037747091',
    TEXT_TAG_TESTING_TROUBLESHOOTING: '4724946507789'
};
